import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "fr",
    load: 'languageOnly',
    fallbackLng: "fr",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      // Path where resources get loaded from
      loadPath: "/locales/{{lng}}/translation.json",
    },
    // Remove 'resources' from here for dynamic loading
  

  });

export default i18n;
